import React from 'react'

import './page-header.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children?: React.ReactNode
    headline: React.ReactNode
    actions?: React.ReactNode
  }
>

const PageHeader = ({className, children, headline, actions, ...props}: Props) => (
  <div {...props} className={cn('PageHeader', {}, className)}>
    <div className="PageHeader__headline">
      {headline}
      {actions && <div className="PageHeader__actions">{actions}</div>}
    </div>
    {children && <div className="PageHeader__content">{children}</div>}
  </div>
)

export default PageHeader
